module.exports = __webpack_public_path__ + "static/media/2.c2bc697b.png";